import { inter } from "../fonts/inter";
import { motion } from "framer-motion";
import HeroBackground from "../components/background/HeroBackground";
import React from "react";
import Image from "next/image";
import AnimatedTitle from "../animations/AnimatedTitle";

const Hero = () => {
  return (
    <motion.section
      className="relative z-10 flex h-[100vh] w-full justify-center"
      id="home"
      initial="initial"
      animate="animate"
    >
      <HeroBackground />
      <div className="mt-10 flex flex-col items-center justify-center sm:mt-0">
        <div
          className={`relative flex flex-col items-center justify-center ${inter.className} pointer-events-none`}
        >
          <Image
            src="/profilePic.jpg"
            width={240}
            height={240}
            className="my-12 h-60 w-60 rounded-full object-cover"
            alt="female software engineer named Sahra"
            priority
          />
          <AnimatedTitle
            text={"Hi, there! I'm Sahra."}
            className={
              "mb-1 text-center text-[32px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]"
            }
            wordSpace={"mr-[10px]"}
            charSpace={"mr-[0.001em]"}
          />
          <span className="px-4 text-center text-sm sm:px-0 sm:text-base md:text-lg xl:text-xl">
            {
              "I bring innovative business to life as a Frontend Software Engineer specialized in React/Next.js applications."
            }
          </span>
        </div>
      </div>
    </motion.section>
  );
};

export default Hero;
